import React from 'react';
import { ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Cell } from 'src/components/Cell';
import { Group } from 'src/components/Group';
import { Avatar } from 'src/components/Avatar';

storiesOf('Avatar', module).add('Default', () => (
  <ScrollView>
    <PanelHeader>👩‍🦰 Avatar</PanelHeader>
    <Group>
      <Cell
        before={
          <Avatar
            size="m"
            mode="user"
            name="John Doe"
            source={{ uri: 'https://unsplash.it/100' }}
          />
        }
      >
        John Doe
      </Cell>
      <Cell before={<Avatar size="m" mode="user" name="Corney Black" />}>Corney Black</Cell>
      <Cell
        before={
          <Avatar size="m" mode="app" name="Wallet" source={{ uri: 'https://unsplash.it/100' }} />
        }
      >
        Wallet
      </Cell>
      <Cell before={<Avatar size="m" mode="app" name="Cockroach Game" />}>Cockroach Game</Cell>
    </Group>
    <Group separator={false}>
      <Cell
        before={
          <Avatar
            size="l"
            mode="user"
            name="John Doe"
            source={{ uri: 'https://unsplash.it/100' }}
          />
        }
      >
        John Doe
      </Cell>
      <Cell before={<Avatar size="l" mode="user" name="Corney Black" />}>Corney Black</Cell>
      <Cell
        before={
          <Avatar size="l" mode="app" name="Wallet" source={{ uri: 'https://unsplash.it/100' }} />
        }
      >
        Wallet
      </Cell>
      <Cell before={<Avatar size="l" mode="app" name="Cockroach Game" />}>Cockroach Game</Cell>
    </Group>
  </ScrollView>
));
